import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ContactAPI from "../../api/ContactAPI";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

function Faq() {
    const { i18n } = useTranslation();
    const [document, setDocument] = useState([]);
    const [openIndices, setOpenIndices] = useState([]);
    const [faq, setFAQ] = useState([]);
    const [header, setHeader] = useState([]);

    const fetchFAQ = async () => {
        try {
            const response = await (i18n.language === 'en' ? ContactAPI.getContactFAQEn() : ContactAPI.getContactFAQ());
            const data = response.data?.faq || [];
            setFAQ(data);
            setDocument(response.data?.document);
            setHeader(response.data);
        } catch (error) {
            console.error("ContactAPI.getContactFAQ", error);
        }
    };

    const toggleAccordion = (index) => {
        setOpenIndices((prevOpenIndices) =>
            prevOpenIndices.includes(index)
                ? prevOpenIndices.filter((i) => i !== index)
                : [...prevOpenIndices, index]
        );
    };

    useEffect(() => {
        fetchFAQ();
    }, [i18n.language]);

    return (
        <>
            <section className="banner bg-news-intro">
                <img
                    className="banner-image w-full"
                    src={"/images/contracts_bg/banner_faq.jpeg"}
                    alt="Hero Banner"
                />
                <div className="headline text-center">
                    <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
                        {header.header}
                    </h1>
                </div>
            </section>
            <section className="content p-4 md:p-8 bg-gray-50">
                <div className="content-container box-news-container">
                    <div className="content-header w-full">
                        {Array.isArray(document) &&
                            document.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex gap-3 cursor-pointer"
                                    onClick={() => window.open(item.documentlink, "_blank")}
                                >
                                    <div className="w-full lg:hidden mt-5 bg-[#E9EAF8] flex flex-col items-center justify-center p-5 font-medium rtl:text-right text-blue-900 border border-[#d6d7e1] dark:border-grey-700 gap-3 rounded-md">
                                        <div className="flex justify-center shadow-md rounded-full bg-blue-900 p-2 md:5 w-[60px] h-[60px]">
                                            <img
                                                src="/images/icons/pdf.svg"
                                                alt="PDF Icon"
                                                className="w-10 h-10"
                                            />
                                        </div>
                                        <h4 className="mt-3 text-left font-bold">{item.title}</h4>
                                    </div>

                                    <div className="hidden lg:flex w-[35%] lg:w-[8%] h-auto mt-5 bg-[#E9EAF8] flex items-center justify-center p-5 font-medium rtl:text-right text-white border border-[#d6d7e1] dark:border-grey-700 gap-3 rounded-md">
                                        <div className="flex justify-center shadow-md rounded-full bg-blue-900 p-4 md:p-2 w-[80px] h-[80px] md:w-[60px] md:h-[60px]">
                                            <img
                                                src="/images/icons/pdf.svg"
                                                alt="PDF Icon"
                                                className="w-10 h-10"
                                            />
                                        </div>
                                    </div>
                                    <div className="hidden lg:flex w-full mt-5 bg-[#E9EAF8] flex items-center justify-between p-5 font-medium rtl:text-right text-blue-900 border border-[#d6d7e1] dark:border-grey-700 gap-3 rounded-md">
                                        <h5 className="text-left font-bold">
                                            {item.title}
                                        </h5>
                                    </div>

                                </div>
                            ))}
                        {Array.isArray(faq) &&
                            faq.map((item, index) => (
                                <div key={index}>
                                    <button
                                        type="button"
                                        className="mt-5 flex items-center justify-between w-full p-5 font-medium rtl:text-right text-black border border-[#d6d7e1] focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-200 dark:border-grey-700 dark:text-black hover:bg-blue-100 dark:hover:bg-[#E9EAF8] gap-3 rounded-md"
                                        onClick={() => toggleAccordion(index)}
                                        aria-expanded={openIndices.includes(index)}
                                        aria-controls={`accordion-arrow-icon-body-${index}`}
                                    >
                                        <h5 className="text-left">{item.question}</h5>
                                        <span className="text-xl rtl:text-left text-blue-900">
                                            {openIndices.includes(index) ? (
                                                <FiMinusCircle />
                                            ) : (
                                                <FiPlusCircle />
                                            )}
                                        </span>
                                    </button>
                                    <div
                                        id={`accordion-arrow-icon-body-${index}`}
                                        className={`${openIndices.includes(index) ? "block" : "hidden"
                                            } mt-5 p-5 border border-[#d6d7e1] dark:border-grey-700 bg-[#e9eaf7] rounded-md`}
                                    >
                                        <p
                                            className="mb-2 text-blue-900 dark:text-blue-900"
                                            dangerouslySetInnerHTML={{ __html: item.answer }}
                                        ></p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </section>
        </>

    )
}

export default Faq;
